import $ from 'jquery';

$( '.js-sort a' ).on( 'click', function ( e ) {
  e.preventDefault();

  var $this = $( this );
  var category = $this.data( 'category' );

  $this.siblings().removeClass( 'active' );
  $this.addClass( 'active' );
  $( '.load-more.button' ).addClass( 'load-hide' );
  //Foreach card we check if the catagory slug exists in the class attributes, hide it if it doesn't have the category class
  $( '.news-card' ).each( function() {
    var card = $( this );

    if ( card.hasClass( category ) || category == 'all' ) {
      card.each( function() {
        card.removeClass( 'hide-card' );
        card.removeClass( 'load-hide' );
      });
    } else {
      card.addClass( 'hide-card' );
    }
  });    
}); 

function myFunction( item, index ) {
  $( '.' + item ).removeClass( 'hide-card' );
  $( '.' + item ).addClass( 'active-tag' );
  $( '.js-tag-active' ).addClass( 'active-tag' );
  $( '#clearFilter' ).addClass( 'active-tag' );
}

function filterEngine(){
  // Put all checked filter value in an array 
  var choices= [];
  $.each( $( "[name='product-filter']:checked" ), function(){
    choices.push( $( this ).val() ); 
  });
  
  // Filter list
  if( choices.length === 0 ){
    $( '.product-card' ).removeClass( 'hide-card' );
    $( '.js-tag-btn' ).removeClass( 'active-tag' );
    $( '.js-tag-active' ).removeClass( 'active-tag' );
    $( '#clearFilter' ).removeClass( 'active-tag' );
  } else {
    $( '.product-card' ).addClass( 'hide-card' );
    $( '.js-tag-btn' ).removeClass( 'active-tag' );
    choices.forEach( myFunction );
  } 
};

$( '.js-tag input' ).on( 'click', function ( ) {
  filterEngine();
  $('#search-input').val( '' );
}); 

//Clicking an active tag clears the tag, reruns filter and hash functions
$( '.js-tag-active button' ).on( 'click', function () {

  var current = $( this ).val();

  $( '.js-tag' ).find( "[value='" + current + "']" ).prop( 'checked', false);
  $( this ).removeClass( 'active-tag' );

  filterEngine();
});

//Clears all active tags and closes dropdown
$( '#clearFilter' ).on( 'click', function( e ) {
  e.preventDefault;
  filterEngine();
  $( '.product-card' ).removeClass( 'hide-card' );
  $( this ).parents( '.product-sort' ).find( "[name='product-filter']" ).prop( 'checked', false );
  $( '.js-tag-btn' ).removeClass( 'active-tag' ); 
  $( '.js-tag-active' ).removeClass( 'active-tag' );
  $( '#clearFilter' ).removeClass( 'active-tag' ); 
  $( '.dropdown' ).removeClass( 'open' );
  $( '.dropdown-info' ).removeClass( 'open' );
});

$( '.dropdown' ).on( 'click', function( e ) {
  e.preventDefault;
  $( '.dropdown' ).toggleClass( 'open' );
  $( '.dropdown-info' ).toggleClass( 'open' );
})

if( $( '.load-more.button' ).length ) {
  $( '.load-more.button' ).on( 'click', function ( e ) {
    e.preventDefault();
    $( '.news-card' ).removeClass( 'load-hide' );
    $( '.load-more.button' ).addClass( 'load-hide' );
  });
}

$( '#search-button' ).on( 'click', function( e ) {
  e.preventDefault();
  var value = $('#search-input').val().toLowerCase();

  $( '.product-card' ).removeClass( 'hide-card' ).filter( function() { //Select all cards and show
    return $(this).addClass( 'load-now' ).find('.header-6, .keywords').text().toLowerCase().indexOf(value) === -1;  //Find the h6 and check if the value is substring of the text. Return true if not found.
  }).addClass( 'hide-card' );  //Hide all cards that that the value is not the substring of text

  if( $( '.product-card:visible').length===0 ){
    $( '.no-results' ).addClass('visible')
  } else {
    $( '.no-results' ).removeClass('visible')
  }
  $( '.product-upgrade' ).addClass( 'load-now' );
});

$('#search-input').on( 'keypress', function( e ){
  if(e.which == 13) { //Checking if the enter key is pressed then triggering a click event on the search button
    $('#search-button').click();
  }
});